import { render, staticRenderFns } from "./CoPaceEventsModal.vue?vue&type=template&id=37163730&scoped=true&"
import script from "./CoPaceEventsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoPaceEventsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37163730",
  null
  
)

export default component.exports